module.exports = __webpack_public_path__ + "static/media/sakshi_img.d96d5855.jpg";